<template>
  <div class="protocol">
    <h1>{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}隐私协议</h1>
    <p>
      使用{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}移动端（简称“本软件”）内容上传发布服务前（简称“本服务”），请务必审慎阅读、充分理解{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}移动端内容上传发布服务协议（简称“本协议”）各条款内容，<em>特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体标识，您应重点阅读。</em> 除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您根据注册页面提示完成注册程序及对本服务的登录、查看、发布内容等行为即表示您已充分阅读、理解并接受本协议的全部内容，并与金山办公达成一致，成为本服务的合法用户。
    </p>
    <p>
      <em>您确认，在您开始使用本服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。特别地，如果您是未成年人，请在您的监护人的同意和指导下使用本服务。</em>
    </p>
    <h2>一、【协议的范围】</h2>
    <p>1.1 本协议是您与金山办公之间关于您使用本服务所订立的协议。“金山办公”是指珠海金山办公软件有限公司或北京金山办公软件有限公司及其相关服务可能存在的运营关联单位，具体到本协议提及的每个金山办公是指珠海金山办公软件有限公司还是北京金山办公软件有限公司还是运营关联单位，将由金山办公结合您的具体情况判断确定。“用户”是指注册、登录、使用本服务的自然人用户以及非自然人用户（包括任何具备或不具备法人主体资格的机构或组织），在本协议中更多地称为“您”，仅限用户在阅读并接受本协议的全部条款后方可使用本服务。“其他用户”是指包括经用户分享后可以查看用户利用本服务上传、发布、传播、分享、储存的内容的其他用户以及其他除用户本人外与本服务相关的用户</p>
    <p>
      1.2由于互联网行业高速发展，您与金山办公签署的本协议列明的条款并不能完整罗列并覆盖您与金山办公所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。<em>因此，金山办公不时公示的相关声明及政策、解读、其他相关专项规则、公告指引和协议以及在本服务页面、帮助中心或类似功能发布的各类规则、实施细则、产品说明、公告等均为本协议的补充协议，上述补充协议一经正式发布，即为本协议不可分割的组成部分与本协议具有同等法律效力，您同样应当遵守。您对前述任何补充协议的接受，即视为您对本协议全部的接受。</em>
    </p>
    <h2>二、【帐号注册与使用规范】 </h2>
    <h2>2.1帐号说明 </h2>
    <p>您按照注册页面提示填写信息完成全部注册程序后，可获得本服务注册账号。您可以利用电子邮箱帐号或手机号进行绑定注册。您有权使用您设置或确认的用户名、电子邮箱帐号、手机号（以下简称“注册账号”）或使用金山办公认可的可用于登录本服务的您在第三方注册的账号（简称“金山办公认可的第三方账号”，如QQ账号/新浪微博账号/小米帐号，金山办公可能随时增加、减少、替换其认可的可用于登录本软件的的第三方账号）及您设置的密码（注册帐号和金山办公认可的第三方账号及您设置的密码统称为“账号”）登录使用本服务。金山办公有权根据用户需求或业务发展需要对帐号注册的方式进行变更，关于您使用帐号的具体规则，除应符合本协议相关约定外，同时金山办公还可能不时发布相关帐号使用协议以及相关规则，您应一并遵守。如您通过金山办公认可的第三方账号登录使用本服务，还应同时遵守第三方关于该第三方帐号的相关使用协议或相关规则（如有）。<em>如您违反该第三方帐号相关使用协议或相关规则，第三方对您依法进行处理的，与金山办公无关，您应独自承担由此产生的一切法律责任。</em></p>
    <h2>2.2注册信息管理</h2>
    <h2>2.2.1 真实合法</h2>
    <p>在使用本服务时，您应当按本服务页面的提示准确完整地提供所需的信息（包括但不限于您的姓名及电子邮件地址、联系电话、联系地址等），以便金山办公在必要时与您联系。<em>您了解并同意，您有义务保持您提供信息的真实性及有效性。</em></p>
    <p><em>您所设置的用户名不得违反国家法律法规及金山办公不时发布的相关服务规则、关于用户名的管理规定（如有），否则金山办公可对您的用户名进行暂停使用或注销等处理，并向主管机关报告。</em></p>
    <p><em>您理解并承诺，您的用户名称等注册信息中不得出现违法和不良信息，没有冒用、关联知名机构或社会名人，您在账号注册过程中需遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。</em></p>
    <p><em>您同意并授权，为了更好的为您提供服务以及确保您的账号安全，金山办公可以根据您提供的手机号码、身份证号码等信息，向全国公民身份号码查询服务中心、电信运营商、金融服务机构等可靠单位发起用户身份真实性、用户征信记录、用户手机号码有效性状态等情况的查询。</em></p>
    <h2>2.2.2 更新维护</h2>
    <p>您应当及时更新您提供的信息，在法律有明确规定要求金山办公对部分用户的信息进行核实的情况下，金山办公将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整的信息。</p>
    <p><em>如金山办公按您最后一次提供的信息与您联系未果、您未按照金山办公的要求及时提供信息、您提供的信息存在明显不实的，您将承担因此对您自身、他人及金山办公造成的全部损失与不利后果。</em></p>
    <h2>2.3账号安全和使用规范</h2>
    <p><em>您的账号为您自行设置并由您保管。建议您务必保管好您的账号和密码，并确保您在每个上网时段结束时退出登录并以正确步骤离开本服务。金山办公将努力采取各种合理的物理、电子和管理方面的安全措施尽力使您的信息不丢失，不被滥用和变造等。尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</em></p>
    <p><em>由于用户账号关联用户信息，仅当有法律明文规定、司法裁定或经金山办公同意，并符合金山办公相关服务规则规定的用户账号转让流程的情况下，您才可进行账号的转让。您的账号一经转让，该账号项下权利义务一并转移。除此外，您的账号不得以任何方式转让（包括但不限于赠与、借用、租用、转让或售卖），否则由此产生的一切责任均由您自行承担。
      除金山办公存在过错外，您应对您账号项下的所有行为结果负责。</em></p>
    <p><em>如您发现任何未经授权使用您账号登录本服务或其他可能导致您账号遭窃、遗失的情况，建议您立即通知金山办公，否则您将自行承担所有由此导致的损失及后果。您理解金山办公对您的任何请求采取行动均需要合理时间，除金山办公存在过错外，金山办公对在采取行动前已经产生的后果不承担任何责任。</em></p>
    <p><em>账号因您主动泄露或遭受他人攻击、诈骗等行为导致的损失及后果，均由您自行承担。</em></p>
    <h2>三、【隐私政策】 </h2>
    <p>金山办公与用户一同致力于用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用本服务时，您同意金山办公按照本条所述隐私政策收集、存储、使用、披露和保护您的个人信息。金山办公希望通过本条隐私政策向您清楚地介绍金山办公收集、使用、保存相关信息（包括但不限于您的个人信息）的目的、方式和范围、以及您拒绝提供个人信息的后果等事项，因此金山办公建议您完整地阅读隐私政策，以帮助您更好地保护您的隐私权。</p>
    <p>如您对本隐私政策有任何疑问，您可以通过本软件或网址为http://edu.wps.cn/ 的网站公布的联系方式与金山办公联系。<em>如果您不同意本隐私政策任何内容，您应立即停止使用本服务。您对本服务的登录、查看、发布内容等行为，即表示您已同意金山办公按照本隐私政策来合法使用和保护您的个人信息。</em></p>
    <h2>3.1 适用范围</h2>
    <p>本条所述隐私政策仅适用于本服务，不适用于金山办公的其他服务或产品。同时需要特别说明的是，本隐私政策不适用于其他第三方（指除您之外的其他方）向您提出的任何请求，包括但不限于个人信息披露请求，例如第三方依托本服务向您提供服务时，您向该第三方提供的个人信息不适用于本隐私政策，金山办公对任何第三方使用由您提供的信息不承担任何责任。</p>
    <h2>3.2 金山办公如何收集信息</h2>
    <p>金山办公收集信息是为了优化本服务，金山办公收集信息的方式如下： </p>
    <p><em>您向金山办公提供的信息。</em>1) </p>
    <p><em>当您注册帐号及您在使用本服务时填写及/或提交的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等）以及使用本服务时所上传、发布或传输的信息</em>。</p>
    <p><em>2) 在您使用服务过程中收集的信息。</em></p>
    <p><em>为了提供并优化本服务，金山办公可能会收集您使用本服务相关的设备信息（包括但不限于设备型号、设备识别码、操作系统版本、分辨率、电信运营商等）、日志信息（比如设备事件信息，例如崩溃、系统活动、硬件设置、您提出请求的日期和时间等）及您通过本服务所上传的内容所包含的信息，例如上传的共享照片或录像的日期、时间或地点等</em>。</p>
    <p><em>3）除上述信息外，金山办公还可能为了改进服务质量的合理需要而收集您的其他信息，包括您与金山办公的客户服务团队联系时您提供的相关信息等。 </em></p>
    <p><em>本条隐私政策所涉信息的收集范围以金山办公适时的技术水平为判断标准。金山办公将尽最大努力力求判断的准确性，但因受到现实技术水平等的限制，金山办公仅依照自有的判断能力进行甄别收集。您已明确知悉上述内容，且认可金山办公的操作，愿意承担因此而可能造成的损失。</em></p>
    <h2>3.3 金山办公如何使用信息</h2>
    <p><em>金山办公利用收集的信息来提供、维护、保护和改进本服务。</em></p>
    <p><em>当您与金山办公联系时，金山办公将会保存您的通信记录，这有助于解决您可能遇到的任何问题。金山办公可能会向您的电子邮件地址发送有关本服务的邮件，例如告知您即将进行的变更或改进。</em></p>
    <p><em>金山办公在您使用本服务的过程中收集到的设备信息等，是为了给您带来更好的用户体验，并提高本服务的总体品质。例如，根据您设备的系统语言设置，金山办公可以用您的系统语言显示本服务的内容。 </em></p>
    <p><em>在不透露您隐私资料的前提下，金山办公有权对整个用户数据库进行分析并对用户数据库进行商业上的利用（包括但不限于公布、分析或以其它方式使用用户访问量、访问时段、用户偏好等用户数据信息）</em></p>
    <h2>3.4 金山办公如何共享信息</h2>
    <strong>金山办公对您的信息承担保密义务，不会出售或出租您的任何信息，金山办公会在下列情况下才将您的信息与第三方共享：
      <br>
      1)    事先获得您的同意或授权。
      <br>
      2)    根据法律法规的规定或行政或司法机构的要求。
      <br>
      3)    向金山办公的关联公司分享您的个人信息。
      <br>
      4)    向可信赖的合作伙伴提供您的个人信息，金山办公可能会与第三方合作向您提供相关服务，在此情况下，如该第三方同意承担与金山办公同等的保护用户隐私的责任，则金山办公可将您的个人信息等提供给该第三方。
      <br>
      5)    如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。
      <br>
      6)   只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议。例如您在本服务上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，金山办公会视情况向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
      <br>
      7)    如您出现违反中国有关法律、法规或者金山办公相关协议或相关规则的情况，需要向第三方披露。
      <br>
      8)    为维护金山办公及其关联公司或其他用户或社会公众的合法权益。</strong><br>
    3.5 Cookie的使用<br>
    <strong>为使您获得更轻松的访问体验，您使用本服务时，金山办公可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账号安全。这些数据文件可能是Cookie，Flash Cookie，或您的设备或关联应用程序提供的其他本地存储（统称“Cookie”）。

      <br>
      请您理解，金山办公提供的本服务部分内容只能通过使用“Cookie”才可得到实现。如果您不同意，您可以修改对Cookie的接受程度或者拒绝金山办公的Cookie，但这一举动在某些情况下可能会影响您安全使用本服务。 </strong><br>
    3.6 信息存储
    <br>金山办公收集的有关您的信息和资料将保存在金山办公及（或）其关联公司【本协议中凡提及关联公司指不时（直接或间接）控制（或与其他方共同控制）该方或可对该方施加重大影响，受该方控制（或受该方与其他第三方的共同控制）或该方能对其施加重大影响，或与该方同受控制和/或重大影响的法律实体。“控制”是指有权决定一个公司的财务和经营政策，并能据以从该公司的经营活动中获取利益。无论如何，（直接或间接）享有该公司50%以上的管理或决策权利（不论是通过表决权、合同或其他方式）均应视为控制该公司。“共同控制”，是指按照合同约定对某项经济活动所共有的控制，仅在与该项经济活动相关的重要财务和经营决策需要分享控制权的投资方一致同意时存在。“重大影响”，是指对一个公司的财务和经营政策有参与决策的权力，但并不能够控制这些政策的制定。无论如何，直接或间接享有该公司20%以上的管理或决策权利（不论是通过表决权、合同或其他方式）均应视为对该公司有重大影响】或合作方的服务器上，这些信息和资料可能传送至您所在国家、地区或金山办公收集信息和资料所在地并在该地被访问、存储和展示。<br>
    3.7 拒绝提供的后果<br>
    您在使用本服务过程中，可能需要填写一些必要的信息，请保持这些信息的真实、准确、合法、有效并注意及时更新，以便金山办公向您提供及时有效的帮助，或更好地为您提供服务。根据相关法律法规和政策，请您填写真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用本服务或在使用过程中受到限制。<br>
    3.8个人信息保护<br>
    您的账号均有安全保护功能，请妥善保管您的账号及密码信息。为保障您的信息安全，金山办公努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。金山办公会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，金山办公将尽力做到使您的信息不被泄漏、毁损或丢失。<strong>尽管有前述安全措施，但同时也请您理解在信息网络上不存在“完善的安全措施”。</strong><br>
    在使用本服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如银行帐号信息、联络<strong>方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，否则由此产生的一切后果，由您自行承担。</strong>如您发现自己的个人信息泄密，尤其是你的帐号及密码发生泄露，请您立即联络金山办公，以便采取相应措施。
    <br>
    您应对通过本服务了解、接收或可接触到的包括但不限于其他用户在内的任何人的个人信息予以充分尊重，<strong>您不应以搜集、复制、存储、传播或以其他任何方式使用其他用户的个人信息，否则，由此产生的后果由您自行承担。</strong><br>
    </strong>3.9 未成年人保护<br>
    金山办公不会在知情的情况下收集未成年人的个人信息。除非所在地法律允许并且监护人同意，未成年人请不要注册账号或发送自己的姓名、住址、电话、电子邮件地址等个人信息给金山办公。如果金山办公不小心收集到了未成年人的信息，金山办公在知情后会尽快删除。如果您认为金山办公可能不当地持有来自于或关于未成年人的信息，请联系金山办公。 </p>
    <br>
    <p><strong>四、【服务规范和内容规范】</strong><br>
      <strong>4.1服务简介及服务规范</strong><br>您使用您的注册账号或金山办公认可的第三方账号在本服务提供的登录入口联网登录后， 您可通过本服务上传、发布或传输相关内容（包括但不限于注册信息、文字、软件、程序、图形、图片、声音、音乐、、音视频、链接等信息或其他资料、针对上述内容的回复、评论或相关链接页面等以及其他使用本服务所产生的内容，以下简称“相关内容”或“内容”）。但您需独立对上述内容和您的所有相关行为承担一切相关的法律责任。<br>同时你还可以评论、回复您自己或其他用户通过本服务上传、发布或传输的相关内容或通过分享功能将上述相关内容通过第三方平台发布，具体可发布的第三方平台范围由用户使用该功能时本服务列明并供用户选择的的为准，您知悉并认可金山办公有权随时根据相关法律法规更新或业务运营的需要增加、减少、变更可供选择<strong>的相关平台范围。使用分享功能的一切行为需要遵守本协议或相关补充协议及相关法律法规的规定。同时您应遵守您拟分享的第三方平台的相关协议或规则，如您违反该第三方平台相关协议或规则，第三方平台根据其审核、举报规则对您依法进行处理的，与金山办公无关，您应独自承担由此产生的一切法律责任。</strong><br>
      <strong>除非有相反证明，一旦您使用本服务上传、发布或传输相关内容，金山办公将认为您是您所上传、发布或传输的内容之著作权拥有人或者您已经获得了实施相关一切行为的全部合法授权。您使用本服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销的、免费的授予金山办公对该内容的存储、使用、发布、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您上传、发布、传输的内容进行商业开发的权利及其相关的宣传和推广等服务的权利；以及再授权给其他第三方以上述方式使用的权利。
        <br>
        您理解并知晓在使用本服务时，所接触的内容和信息来源广泛，金山办公无法控制用户上传、发布或传输的内容的合法性、完整性、可靠性、准确性、真实性、可用性、安全性、正当性以及其来源、归属，也因此金山办公不会也无法承担任何预先审核义务或保证责任。您理解并认可您可能会接触到不正确的、令人不快的、不适当的或令人厌恶的内容和信息，您不会以此追究金山办公的相关责任。
        <br>
        金山办公提醒您应该通过自己的谨慎判断确定您上传、发布或传输的内容或接触到内容的合法性、有效性等。金山办公不对您上传、发布或传输的任何内容或接触到的任何内容背书、推荐或表达观点，也不对任何内容的错误、瑕疵及产生的任何损失或任何损害承担任何责任（包括但不限于因相关内容不完整、不合法或其他一切因相关内容而引致之任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其它损失等），您需对上述相关内容独立承担所有相关的法律责任。
        <br>
        您知悉并认可金山办公可能与第三方合作提供本服务，本服务的一部分可能由第三方提供或运营，您通过本服务上传、发布、传输的内容可能存储在第三方服务器，对第三方原因导致您丢失通过本服务上传、发布、传输的内容、或未能上传或造成其他损失的，金山办公不承担任何责任。</strong><br>
      <strong>4.2 内容规范</strong><br>
      <strong>您理解并保证您使用本服务上传、发布或传输的相关内容(包括您的帐号等注册信息）不含有下述内容:</strong><br>（一）反对宪法确定的基本原则的；
      <br>（二）危害国家统一、主权和领土完整的；
      <br>（三）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
      <br>（四）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
      <br>（五）宣扬邪教、迷信的；
      <br>（六）散布谣言，扰乱社会秩序，破坏社会稳定的；
      <br>（七）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
      <br>（八）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；
      <br>（九）危害社会公德，损害民族优秀文化传统的；
      <br>（十）任何非法、有害、胁迫、滥用、骚扰、侵害、中伤、粗俗、猥亵、有害或种族歧视的或道德上令人不快的；
      <br>（十一）以任何方式危害未成年人的；
      <br>（十二）以非法民间组织名义活动的；
      <br>（十三）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；
      <br>（十四）侵害包括但不限于他人名誉权、肖像权、隐私权、知识产权、商业秘密等合法权利的；
      <br>（十五）含有传播骚扰、欺诈虚假广告或违法广告等广告信息及垃圾信息、谣言、 色情及色情擦边内容、暴力内容、赌博内容、涉黑内容或含有任何性或性暗示的；
      <br>（十六）其他违反法律法规、政策及公序良俗、社会公德或干扰本服务正常使用和侵犯其他用户或第三方合法权益的。
      <br>
      <strong>如果您上传、发布或传输的内容含有违反法律法规的或任何其他不当内容的，或者有任何第三方告知金山办公您使用本服务上传、发布或传输的相关内容侵犯其合法权益的，您同意金山有权依据本协议约定删除任何前述相关内容并暂停或终止您使用本服务的全部或部分，您还将直接承担因此导致的其他一切不利后果。同时，如因此给金山办公造成不利后果的，您还应负责消除影响，并且赔偿金山办公因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。</strong></p>
    <br>
    <p><strong>五、【用户行为规则】
    </strong><br>5.1 本条所述用户行为是指用户使用本服务进行的任何行为，包括但不限于注册、登录、上传、发布、传输、分享内容以及其他使用本服务所进行的行为。
      <br>5.2您同意在使用本服务过程中，遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》等有关计算机及互联网规定的法律、法规。
      <br>5.3您不得利用本服务进行下列禁止的行为：
      <br>1)伪造标题或以其他方式操控相关内容，使他人误认为相关内容为金山办公或第三方所上传；
      <br>2)将无权上传、发布或传输的相关内容进行上传、发布、发送电子邮件或以其他方式传输；
      <br>3)参与任何非法或有可能非法的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；
      <br>4)赌博、提供赌博数据或透过任何方法诱使他人参与赌博活动；
      <br>5)通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入本服务、收集或处理通过本服务所提供的内容；
      <br>6)参与任何“框架”、“镜像”或其他技术，目的是模仿本服务的外观和技术原理；
      <br>7)干预或试图干预任何您或任何其他方接入本服务；
      <br>8)故意散播病毒、网络蠕虫、特洛伊木马病毒、已损毁的档案或其他恶意代码或项目；
      <br>9)未经他人明确同意，分享或发布该等人士可识别个人身份的相关内容；
      <br>10)对本服务进行解编、反向编译或逆向工程，或试图作出上述事项；
      <br>11)故意或非故意违反任何相关的中国法律、法规、规章、条例等其他具有法律效力的规范；
      <br>12）侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利；
      <br>13）其他违反法律法规规定、侵犯其他用户合法权益、干扰本服务或相关产品正常运营或金山办公未明示授权或金山办公认为不当或有害的其他行为。
      <br>
      <strong>如您认为其他用户通过本服务上传、发布、传输的内容侵犯您的合法权利，您有权向金山办公提交书面通知（该书面通知应当包含下列内容：（一）您的姓名、联系方式和地址；（二）要求删除或者断开链接的内容的名称和网络地址；（三）构成侵权的初步证明材料；该书面通知包含的每页内容您均应亲笔签名，您可以快递发送纸质版本形式发送至金山办公如下地址：北京市海淀区小营西路33号金山软件大厦，或将上述书面通知的电子扫描件文档按照网址为：http://edu.wps.cn/ 的网页上或本服务相关页面的上传操作的指引提交给金山办公，否则金山办公将视为未收到您的书面通知而无义务删除您提出的涉嫌侵权的内容或者断开与您提出的涉嫌侵权的内容的链接），要求金山办公删除相关涉嫌侵权的内容或断开与该等涉嫌侵权的内容的链接。金山办公将在收到您提交的书面通知后删除您在书面通知书里要求删除的涉嫌侵权的内容或断开与该等涉嫌侵权内容的链接并将您的通知书的内容通过站内消息、电子邮件的方式转送给涉嫌侵权的该其他用户，即为金山办公履行完毕向涉嫌侵权的该其他用户转送该通知书的义务，同时您知悉并认可该通知书内容的真实性、准确性、完整性均由您独立负责，如金山办公依据您提交的书面通知删除相关涉嫌侵权的内容或断开与该等涉嫌侵权的内容的链接的行为招致任何一方追究责任或给任何一方造成任何损失，您均应为金山办公提供抗辩、代替金山办公独立承担全部责任，保证金山办公不因此遭受任何损失，如金山办公为此遭受任何损失，将由您承担全部赔偿责任。如本款上述涉嫌侵权的该其他用户认为金山办公依据您的通知书删除或断开链接的涉嫌侵权的内容未侵犯他人权利的，其有权向金山办公提交书面说明，要求恢复被删除的内容或者恢复与被断开的内容的链接，金山办公将在接到其的书面说明后恢复被删除的内容或者恢复与被断开的内容的链接，同时将该书面说明通过站内消息、电子邮件的方式转送给您，即为金山办公履行完毕向您转送该书面说明的义务。您知悉并认可上述涉嫌侵权的该其他用户向金山办公提交的书面说明内容的真实性、准确性、完整性均由该涉嫌侵权的其他用户独立负责。即便上述涉嫌侵权的该其他用户向金山办公提交的书面说明内容不真实、不准确、不完整，金山办公对其依据该书面说明恢复被删除的内容或者恢复与被断开的内容的链接的行为以及因此给您或任何一方造成的任何损失均不承担任何责任。</strong>
      <br>
      <strong>您理解并认可，在任何情况下，金山办公一旦合理地认为您的行为可能违反法律、法规或本协议或有任何第三方告知金山办公您使用本服务上传、发布或传输的相关内容侵犯其合法权益的，金山有权在不预先通知您的情况下立即删除相应相关内容并暂停或终止您使用本服务的全部或部分，即便您使用本服务上传、发布或传输的相关内容有可能最终未被有管辖权的司法机构认定为非法或侵犯任何第三方的合法权益。</strong></p>
    <br>
    <p><strong>六、【数据的储存】</strong><br>
      <strong>6.1 金山办公不对您在本服务中相关数据的删除或储存失败负责。</strong><br>
      <strong>6.2 金山办公有权根据实际情况自行决定单个用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份本服务中的相关数据。</strong><br>
      <strong>6.3 如果您停止使用本服务或服务被终止或取消，金山办公可以从服务器上永久地删除您的数据。服务停止、终止或取消后，金山办公没有义务向您返还任何数据。</strong></p>
    <br>
    <p><strong>七、【风险及免责】
    </strong><br>
      <strong>7.1 您理解并同意，本服务仅为用户提供内容上传、发布、分享、传播及获取的平台，您必须为自己帐号下的一切行为独立负责，包括但不限于保证您所发表内容的合法性、完整性、可靠性、准确性、真实性、可用性、安全性、正当性等以及自行承担任何与本服务相关行为产生的结果。金山办公不就您的任何行为做任何形式的保证。<br>
        您应对您上传、发布或传输的内容以及通过本服务接触的内容自行加以判断，并承担因此而引起的所有风险和后果，包括因对内容真实性、合法性、准确性、有效性的依赖而产生的风险。金山办公无法且不会对因您自身的任何行为而导致的损失或损害承担任何责任。
        <br>
        7.2金山办公负责"按现状"和"可得到"的状态向您提供本服务。金山办公不保证所提供服务能完全满足您的要求，不保证本服务不中断，亦不对本服务的安全性、正确性、及时性、合法性做任何担保。如因系统维护或升级而需暂停服务时，将事先公告。若因线路及非金山办公控制范围内的硬件故障或其它不可抗力而导致暂停服务的，暂停服务期间造成的一切不便与损失，金山办公不负任何责任。 <br>
        7.3您理解并同意，金山办公保留因业务发展需要单方面对本服务的全部或部分服务内容在任何时候不经任何通知的情况下变更、暂停、限制、终止或撤销的权利，您需承担此风险。
        <br>
        7.4金山办公通过中华人民共和国境内的设施控制和提供本服务，金山办公不担保控制或提供的服务在其他国家或地区是适当的、可行的，任何在其他司法辖区使用本服务的您应自行确保其遵守当地的法律法规，金山办公对此不承担任何责任。
        <br>
        7.5您应妥善保管好您的帐号信息和上传、发布或传输的相关内容，在法律允许的最大范围内，因任何原因（包括但不限于由于计算机系统问题、黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常浏览的不可抗力以及因您主动泄露或遭受他人攻击、诈骗等行为而造成的）导致的您的帐号信息、您上传、发布或传输的相关内容的灭失、损坏、被盗用或被窜改等等一切损失和后果，均由您自行承担。
        <br>
        7.6您理解并同意，您通过本服务上传、发布、传输的内容一经发布即向公众传播和共享，可能会被其他用户或第三方复制、转载、修改或做其他用途，脱离您的预期和控制，用户应充分意识到此类风险的存在，任何您不愿被他人获知的信息都不应通过本服务上传、发布、分享、传播。
        <br>
        7.7. 如果您发现任何人违反本协议规定或以其他不当的方式使用本服务，请立即向金山办公举报或投诉。 金山办公依据本协议约定获得处理违反有关法律法规或本协议或相关补充协议或行为的权利，但该权利不构成金山办公的义务或承诺，金山办公不能保证及时发现违反有关法律法规或本协议或相关补充协议的情形或进行相应处理。</strong></p>
    <br>
    <p><strong>八、【知识产权声明】</strong><br>
      8.1 金山办公在本服务中提供的技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等，下同）及其他相关权利归金山办公所有，用户在使用本服务中所产生的内容的知识产权归用户或相关权利人所有。
      <br>8.2 除另有特别声明外，金山办公提供本服务时所依托软件的所有知识产权及其他相关权利均归金山办公所有。
      <br>8.3 金山办公在本服务中所使用的“{{this.$store.state.organizationMessage ? this.$store.state.organizationMessage.organName : '才博'}}”、“金山办公”及其他相关的等商业标识的所有知识产权归金山办公所有。
      <br>8.4 上述及其他任何本服务包含的或相关的内容的知识产权均受到法律保护，未经金山办公、用户或相关权利人书面许可，任何人不得以任何形式进行使用或创造相关衍生作品。
    </p>
    <br>
    <p><strong>九、【法律责任】
    </strong><br>
      <strong>9.1 如果金山办公发现或收到他人举报或投诉您违反本协议约定或相关补充协议或相关法律法规的，金山办公有权不经通知随时对相关内容采取删除或断开链接等措施，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用全部或部分功能、帐号封禁直至注销的处罚，并公告处理结果。
        <br>
        9.2 您理解并同意，金山办公有权依合理判断对违反本协议约定或相关补充协议或相关法律法规的行为进行处罚，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
        <br>
        9.3 您理解并同意，因您违反本协议约定或相关补充协议或相关法律法规规定，导致或产生的任何第三方主张的任何索赔、要求或损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失，下同）或任何法律责任，您应独立承担并保证金山办公与合作公司、关联公司免受任何损害。因此给金山办公与合作公司、关联公司造成任何损失的，您应当全部赔偿。</strong></p><br>
    <p><strong>十、【广告】</strong><br>
      10.1 您认可金山办公有权通过本软件的任何页面、任何位置及/或在向您提供本服务时可展示广告和推销，无论是针对自身产品/服务或第三方产品/服务。
      <br>10.2 金山办公展示广告和推销的方式、模式和范围可不经向您特别通知而变更。
      <br>10.3 您应意识到作为本服务一部分展示给您的内容，包括但不限于本服务中的广告及服务中的赞助内容，可能受知识产权的保护。<strong>您不得修改、租赁、出租、借贷、出售、分发该内容（无论全部还是部分）或根据该内容创作衍生作品，除非金山办公或内容权利人在相关协议、相关业务规则中特别告知用户可以为之。</strong><br>
      <strong>10.4.您经由本服务与广告商进行通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及前述交易其他任何相关条款、条件、保证或声明，完全为您与前述广告商之间之行为，金山办公不承担对广告及广告商进行审查、甄别之义务</strong>。
      <br>
      <strong>10.5.前述任何交易或前述广告商出现于本服务所生之任何性质的损失或损害，您同意金山办公不予负责。</strong></strong></p>
    <br>
    <p><strong>十一、【协议的生效与变更】</strong><br>11.1 11.1 您根据注册页面提示完成注册程序及对本服务的登录、查看、发布内容等行为即视为您已阅读并同意受本协议的约束。
      <br>11.2 金山办公有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的协议条款。
      <br>11.3 如您不同意新协议，您应当于新本协议确定的生效之日起停止使用本服务；如您在新本协议生效后仍继续使用本服务，则视为您同意已生效的新协议并仍受该协议的约束。</p><br>
    <p><strong>十二、【其他】</strong><br>12.1本协议签订地为中华人民共和国北京市海淀区。
      <br>
      <strong>12.2本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆法律；如法律无相关规定的，参照商业惯例及/或行业惯例。您因使用本服务所产生及与本服务有关的争议，由金山办公与您协商解决。协商不成时，任何一方均可向被告所在地人民法院提起诉讼。</strong><br>
      12.3 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。为维护您自身权益，建议您仔细阅读各条款具体表述。
      <br>12.4 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。<br>
      至此，您肯定已经详细阅读并已理解本协议，并同意严格遵守各条款和条件。
      <br>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
  },
  methods: {
  },
  beforeCreate () {
  },
  created () {
  },
  beforeDestroy () {
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.protocol {
  line-height: 2;
  font-size: rem(22);
  padding: rem(10);
  h1 {
    text-align: center;
    font-size: rem(26);
  }
  h2, p {
    text-align: left;
  }
}
</style>
